export default "__VITE_ASSET___xJUBmCR__"